import { render, staticRenderFns } from "./imgpage.vue?vue&type=template&id=239cc9e5&scoped=true"
import script from "./imgpage.vue?vue&type=script&lang=js"
export * from "./imgpage.vue?vue&type=script&lang=js"
import style0 from "./imgpage.vue?vue&type=style&index=0&id=239cc9e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239cc9e5",
  null
  
)

export default component.exports